import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useDispatch, connect } from 'react-redux';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { NavBarNames } from '../../../config/NavBarNameList';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import BaseListContainer from '../../base/BaseListContainer';
import DeletePrompt from '../../../components/base/DeletePrompt';
import { useLocation, useHistory } from 'react-router-dom';
import { ActionsDropdownForItem } from '../../../components/base/ActionsDropdown';
import {
  PublishTagType,
} from '../../../config/CustomEnums';
import { PermissionCodes } from '../../../config/PermissionCodes';
import AuthButton from '../../../components/base/AuthButton';
import Filter from './Filter';

const SplashAdList = ({
  splashAdList,
  listDisplayFields,
  checkedList,
  pageInfo,
  totalCount,
  totalPage,
}) => {
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [deleteItems, setDeleteItems] = useState([]);
  const deletePks = deleteItems?.map(item => item.pk);
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();

  const searchQuery = queryString.parse(location.search);
  let currentPage = parseInt(searchQuery?.page);
  if (isNaN(currentPage)) {
    currentPage = 1;
  }

  const searchKey = searchQuery?.search;
  const fetchData = () => {
    dispatch({
      type: 'splashAd/getCurrentPageSplashAds',
      payload: {
        ...searchQuery,
        page: currentPage,
        searchKey,
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, [location]);

  const groupActions = [
    {
      name: 'Delete',
      action: () => {
        setDeleteItems(checkedList);
        setShowDeletePrompt(true);
      },
      requires: PermissionCodes.changeSplashAd,
    },
  ];

  const orderChange = (item, order) => {
    if (item.displayPriority === order) {
      return;
    }
    dispatch({
      type: 'splashAd/createOrUpdateSplashAd',
      payload: {
        id: item.pk,
        displayPriority: order,
        originalSplashAd: item,
        afterAction: () => history.push(location),
      },
    });
  };

  const tabs = [
    {
      name: 'List Of Splash Ad',
      content: (
        <BaseTabListContainer
          hideTab={true}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{ hasFilter: true, componment: Filter }}
          listContent={
            <BaseListContainer
              fields={listDisplayFields}
              dataList={splashAdList}
              totalPage={totalPage}
              currentPage={currentPage}
              model={'splashAd'}
              permissionGroup={PermissionCodes.splashAd}
              deleteInfo={{
                data: [],
                title: 'Splash ad',
                relatedName: '',
                onComfirm: {},
                relatedSections: null,
              }}
              sortable
              sortDisabled={false}
              rankDisabled
              onSortEnd={(oldIndex, newIndex) => {
                const newOrderObject = splashAdList[newIndex];
                const movedItem = splashAdList[oldIndex];
                orderChange(movedItem, newOrderObject.displayPriority)
              }}
              onOrderChangedByEdit={(item, newOrder) => {
                orderChange(item, newOrder)
              }}
              actions={['Edit', 'Delete']}
              useCustomCommonActions
              customCommonActions={(item) => {
                const actions = [
                  {
                    name: 'Edit',
                    action: () => {
                      history.push(`splash_ad/${item.pk}/edit/`);
                    },
                    requires: PermissionCodes.changeSplashAd,
                  },
                  {
                    name: 'Delete',
                    action: () => {
                      setDeleteItems([item]);
                      setShowDeletePrompt(true);
                    },
                    requires: PermissionCodes.changeSplashAd,
                  },
                ];
                return (
                  <ActionsDropdownForItem
                    object={item}
                    actions={actions}
                    otherActions={[
                      {
                        name:
                          item.status === PublishTagType.published
                            ? 'Unpublish'
                            : 'Publish',
                        action: () => {
                          dispatch({
                            type: 'splashAd/publishOrUnpublishSplashAd',
                            payload: {
                              id: item.pk,
                              publish: item.status !== PublishTagType.published,
                              afterAction: fetchData,
                            },
                          });
                        },
                        requires: PermissionCodes.changeSplashAd,
                      },
                    ]}
                  />
                );
              }}
            />
          }
        />
      ),
    },
  ];
  const buttons = [
    <AuthButton
      title="Create Splash Ad"
      action={() => {
        history.push('splash_ad/create');
      }}
      requires={PermissionCodes.changeSplashAd}
    />,
  ];
  return (
    <>
      <CustomListComponent
        caution={{
          detail: "",
          title: NavBarNames.splashAd,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={true}
      />
      <DeletePrompt
        data={deleteItems}
        title="Splash ad"
        show={showDeletePrompt}
        onClose={() => setShowDeletePrompt(false)}
        onConfirm={() => {
          setShowDeletePrompt(false);
          setDeleteItems([]);
          dispatch({
            type: 'splashAd/delete',
            payload: {
              deletePks,
              afterAction: fetchData,
            },
          });
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  listDisplayFields: state.splashAd.listDisplayFields,
  pageInfo: state.splashAd.pageInfo,
  totalCount: state.splashAd.totalCount,
  totalPage: state.splashAd.totalPage,
  splashAdList: state.splashAd.currentPageSplashAdList,
  checkedList: state.splashAd.checkedList,
});

export default connect(mapStateToProps)(SplashAdList);
